import Radio from 'backbone.radio';
import OverwriteDraftDialog from '@/views/dialogs/overwrite_draft';

    var globalCh = Radio.channel('global');
    function show_overwrite_draft_dialog(callback, is_product) {
        globalCh.request('showDialog', new OverwriteDraftDialog({
            callback: callback
        }));
    }
    export default show_overwrite_draft_dialog;

